import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VeeValidate from 'vee-validate'
import { ClientTable,ServerTable } from 'vue-tables-2'
import JsonExcel from 'vue-json-excel'
import 'bootstrap'
import VueI18n from 'vue-i18n'
import messages from './translate'
import helpers from './helpers'
import daterangepicker from 'daterangepicker'

window.moment = require('moment')

// Define jQuery
global.jQuery = require('jquery')
var $ = global.jQuery
window.$ = $

Vue.use(VeeValidate)
Vue.mixin(helpers)

VeeValidate.Validator.extend('newUserPassword', {
  // Custom validation message
  getMessage: (field) => `The password must contain at least 1 uppercase & lowercase letter, 1 special character, 1 digit and between 6-10 characters`, //${field}
  // Custom validation rule
  validate: (value) => new Promise(resolve => {
    const special = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/

    resolve({
      valid: (/(?=^.{6,10}$)(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[^A-Za-z0-9]).*/.test(value)) && (special.test(value))
    })
  })
})

Vue.use(ClientTable)
Vue.use(ServerTable)
Vue.use(VueI18n)
Vue.component('downloadExcel', JsonExcel)

Vue.config.productionTip = false
Vue.config.devtools = true


const i18n = new VueI18n({
  locale: store.getters.lang,
  messages
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
